<template>
  <article class="banner">
    <div class="banner__img-wrap">
      <div class="banner__img"></div>
    </div>
    <div class="banner__content">
      <div class="banner__line"></div>
      <div class="blur"></div>
      <slide-in :delay="2000">
        <span class="-decor">Social media</span>
      </slide-in>
      <slide-in :delay="2100">
        <h2 class="banner__title" ref="title">
          {{ $t("get_closer") }}
        </h2>
      </slide-in>
      <slide-in :delay="2250">
        <p class="banner__abstract">
          {{ $t("banner_description") }}
        </p>
      </slide-in>
      <slide-in :delay="2400" direction="right">
        <a
          href="https://twitter.com/larianstudios"
          target="_blank"
          class="btn"
          id="pad-banner"
          pad-up="go:#pad-home"
          pad-left="go:#pad-get-game,#pad-play"
          pad-down="go:#pad-merch-widget"
        >
          {{ $t("read_more") }}
        </a>
      </slide-in>
    </div>
  </article>
</template>

<script>
export default {
  name: "Banner",
  props: {},

  data() {
    return {
      sliderOptions: {
        prevNextButtons: false,
        wrapAround: true,
        align: "left",
        pageDots: true,
        resize: true,
        setGallerySize: false
      },
      newses: []
    };
  },

  methods: {
    getImage(image) {
      return image
        ? `${process.env.VUE_APP_API_HOST}${image.url}`
        : "require(./assets/img/jpg/main.png)";
    }
  },

  mounted() {}
};
</script>

<style lang="scss" scoped>
.banner {
  display: flex;
  flex-direction: column;
  width: 35vw;
  height: 42vh;
  margin-bottom: 4vh;

  &__img-wrap {
    height: 18vh;
    flex-shrink: 0;
    overflow: hidden;
  }

  &__img {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center top;
    background-image: url("~@/assets/img/jpg/banner.jpg");
    transition: transform 0.3s ease;
  }

  &__content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 1.2vw 3vw 1.2vw 3vw;
    position: relative;
    z-index: 1;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: $black;
      opacity: 0.4;
      z-index: -1;
    }

    .blur {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      backdrop-filter: blur(12px);
      filter: blur(1px);
      z-index: -1;
    }
  }

  &__line {
    position: absolute;
    top: calc(1.2vw + 25px);
    transform: translateY(calc(-100% - 1.2vw - 25px));
    left: 0;
    width: 2px;
    height: 35px;
    background: $yellow;
    animation: slide-in 500ms forwards;
    animation-delay: 2800ms;
  }

  .-decor {
    font-size: 10px;
    margin-bottom: 10px;
  }

  &__title {
    color: $white;
    font-size: 18px;
    margin-bottom: 10px;
  }

  &__abstract {
    font-size: 14px;
    color: $white-70;
    display: none;
  }

  .btn {
    margin-top: 10px;
  }

  &:hover {
    .banner__img {
      transform: scale(1.1);
    }
  }
}

@media screen and (min-width: $screen-medium) {
  .banner {
    height: 48vh;

    .-decor {
      font-size: 12px;
    }

    &__title {
      font-size: 22px;
    }

    &__abstract {
      display: block;
    }
  }
}

@keyframes slide-in {
  100% {
    transform: translateY(0%);
  }
}
</style>

<style lang="scss">
.banner__abstract {
  p {
    margin: 0;
  }
}
</style>
